module.exports = __webpack_public_path__ + "static/img/16.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/16.png
// module id = EXoD
// module chunks = 0